import { Channel } from 'spyne';
import { ChannelSlideshowTraits } from 'traits/channel/channel-slideshow-traits.js';

export class ChannelSlideshow extends Channel {
  constructor(name, props = {}) {
    name = 'CHANNEL_SLIDESHOW';
    props.traits = [ChannelSlideshowTraits];
    // No replay: DISPLAY_SLIDE is a request to act, and every consumer (the
    // container and its slides) exists before the first emission.
    props.replay = false;
    super(name, props);
    this.props.isActive = false;
    this.props.currentSlideNum = 0;
    this.props.maxSlideNum = 0;
  }

  onRegistered() {
    this.channelSlideshow$OnRegistered();
  }

  addRegisteredActions() {
    return [
      'CHANNEL_SLIDESHOW_ACTIVATED_EVENT',
      'CHANNEL_SLIDESHOW_DEACTIVATED_EVENT',
      'CHANNEL_SLIDESHOW_DISPLAY_SLIDE_EVENT',
      ['CHANNEL_SLIDESHOW_VIEWPORT_REQUEST', 'channelSlideshow$OnViewportReport'],
    ];
  }
}
